<template>
  <div>
    <CCard>
      <CCardBody>
        <CButton style="width: 100px" block color="primary">
          <router-link
            class="router-link"
            :to="{ path: '/profissionais', query: { type: 'a' } }"
            >Cadastrar</router-link
          >
        </CButton>
      </CCardBody>
    </CCard>
    <CModal class="modal-excluir-consulta" :show.sync="showModal">
      <div class="div-body-modal">
        <img
          src="../../../assets/atencao.jpg"
          width="120px"
          height="120px"
          alt=""
        />
        <h4>ATENÇÃO</h4>
        <p style="text-align: center;">{{ msgModal }}</p>

        <button
          type="button"
          @click="showModal = false"
          v-show="btn_voltar_inModal"
        >
          VOLTAR
        </button>
      </div>
    </CModal>
    <!-- <CModal
      :show.sync="showModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      color="warning"
    >
      <CCardBody>
        <CDataTable
          :items="servico_profissional"
          :fields="fields_servico_profissional"
          :noItemsView="not_found"
          column-filter
          hover
          sorter
          small
          :fixed="fixed"
          :items-per-page="5"
          :dark="dark"
          pagination
        >
        </CDataTable>
        <CButton color="primary" square size="sm" @click="cancelarModal"
          >VOLTAR</CButton
        >
      </CCardBody>
      <template #header>
        <h4 class="modal-title">
          Serviço existente para este profissional.
        </h4>
        <CButtonClose @click="cancelarModal()" class="text-white" />
      </template>
    </CModal> -->
    <CAlert
      color="success"
      id="sucesso"
      name="sucesso"
      :show.sync="validacoes.sucesso"
      closeButton
      >{{ validacoes.msg }}</CAlert
    >

    <CCard>
      <CCardBody>
        <CDataTable
          :items="profissionais"
          :fields="fields"
          :noItemsView="not_found"
          column-filter
          hover
          sorter
          small
          :fixed="fixed"
          :items-per-page="10"
          :dark="dark"
          pagination
          clickableRows
          @row-clicked="perfilProfissional($event)"
        >
          <template #item="{ item }">
            <td>
              <CBadge :color="getBadge(item.user_status)">{{
                item.user_status
              }}</CBadge>
            </td>
          </template>
          <template #acao="{ item, index }">
            <td class="py-4">
              <CButton color="primary" variant="outline" square size="sm">
                <router-link
                  class="router-link-ver"
                  :to="{
                    path: '/profissionais',
                    name: 'Profissionais',
                    query: { id: item.id, type: 'b' },
                  }"
                  >VER</router-link
                >
              </CButton>
            </td>
            <td class="py-4">
              <CButton
              v-if="user == 1"
                color="danger"
                variant="outline"
                square
                size="sm"
                @click="excluir(item, index)"
                >EXCLUIR</CButton
              >
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "ListarPessoas",
  data() {
    return {
      showModal: false,
      btn_voltar_inModal: false,
      msgModal: "",
      desativado: false,
      not_found: {
        noResults: "Nenhum registro encontrado",
        noItems: "Nenhum registro encontrado",
      },
      profissionais: [],
      fields: [
        { key: "name", label: "Nome", _style: "min-width:200px" },
        { key: "crp", label: "CRP", _style: "min-width:100px;" },
        { key: "email", label: "E-mail", _style: "min-width:100px;" },
        { key: "phone", label: "Telefone", _style: "min-width:40px;" },
        { key: "city", label: "Cidade", _style: "min-width:40px;" },
        {
          key: "item",
          label: "Status",
          sorter: false,
          filter: false,
        },
        {
          key: "acao",
          label: "",
          sorter: false,
          filter: false,
        },
      ],
      fields_servico_profissional: [
        {
          key: "date_at",
          label: "Data do Serviço",
          _style: "min-width:200px",
          filter: false,
        },
        {
          key: "servico",
          label: "Serviço",
          _style: "min-width:200px",
          filter: false,
        },
      ],
      servico_profissional: [],
      // validacoes
      validacoes: {
        sucesso: false,
        msg: false,
      },

      collapseDuration: 0,
      details: [],
      usuario: {
        id: localStorage.id,
        tipo: localStorage.tipo,
      },
      caption: {
        type: String,
        default: "Table",
      },
      hover: true,
      striped: true,
      bordered: false,
      small: true,
      fixed: true,
      dark: false,
      user: null
    };
  },
  methods: {
    getBadge(status) {
      return status == "Ativo"
        ? "success"
        : status === "Desativado"
        ? "danger"
        : "";
    },
    ListarProfissionais() {
      this.$http
        .get(process.env.VUE_APP_API_BASE_URL + "profissionais-lista")
        .then((res) => res.json())
        .then(
          (payload) => {
            payload.forEach((elem) => {
              if (elem.city) {
                elem.city = elem.city
                  .split(" ")
                  .map(
                    (nome) =>
                      nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase()
                  )
                  .join(" ");
              } else {
                elem.city = "-";
              }
              if (!elem.crp) {
                elem.crp = "-";
              }
              if (!elem.email) {
                elem.email = "-";
              }
              if (!elem.phone) {
                elem.phone = "-";
              }
              elem.name = elem.name
                .split(" ")
                .map(
                  (nome) =>
                    nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase()
                )
                .join(" ");
            });
            this.profissionais = payload;

            this.profissionais.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
          },
          (err) => {
            this.$router.push("/dashboard");
          }
        );
    },
    cadastrar() {
      this.$router.push("/cadastrar-profissional");
    },

    editar(item) {
      this.$router.push({
        name: "Editar-Profissional",
        params: {
          id: item.id,
        },
      });
    },
    excluir(item) {
      event.stopPropagation()
      this.$http
        .get(
          `${process.env.VUE_APP_API_BASE_URL}profissional-servico/${item.id}`
        )
        .then((res) => res.json())
        .then((res) => {
          if (res.acess === "Negado") {
            this.msgModal =
              "Não é possível excluir o profissional pois o mesmo possui consultas agendadas em seu nome.";
            this.showModal = true;
            this.btn_voltar_inModal = true;
          } else {
            this.showModal = false;
            this.validacoes.msg = "Profissional excluído com sucesso.";
            this.validacoes.sucesso = true;
            setTimeout(() => {
              this.validacoes.sucesso = false;
              this.ListarProfissionais();
            }, 2000);
          }
        
        });
    },
    cancelarModal() {
      this.showModal = false;
    },
    perfilProfissional(item) {
      this.$router.push({
        path: "/profissionais",
        name: "Profissionais",
        query: { id: item.id, type: "b" },
      });
    },
   
  },

  mounted() {
    this.user = localStorage.getItem('type')
    this.ListarProfissionais();
  },
};
</script>
<style scoped>
.pb-4,
.py-4 {
  padding: 10px !important;
}
.div-body-modal {
  text-align-last: center;
}
.div-body-modal button {
  background: red;
  border: none;
  font-weight: 500;

  width: 10vw;
  border-radius: 10px;
  height: 2vw;
  color: white;
  transition: all 0.3s;
}
.div-body-modal button:hover {
  background: white;
  font-weight: 500;
  color: red;
  border: 1px solid red;
  transition: all 0.3s;
}
.modal-excluir-consulta h6 {
  text-align-last: center;
  margin-top: 3vw;
}
.btn-modal {
  margin-left: 10px;
}
</style>
